import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReservoir = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 8",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		d: "M1.08.54V5.4c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V.54"
	})
});
export default SvgReservoir;
